// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Certification Styles */

.certifications-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9ef;
}

.create-certification,
.edit-certification {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.create-certification .btn-add {
  margin-bottom: 0;
}

.exploration-selector,
.culture-selector {
  display: flex;
  color: #333;
  background-color: #f0f0f0;
  border: 1px solid #a1a1a1;
  padding: 10px;
  border-radius: 5px;
  margin-right: 2rem;
}

.exploration-selector:hover,
.culture-selector:hover {
  border: 2px solid #27ae60;
  outline: none;
}

/* Pilares Buttons Styles */

.pilares-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9ef;
}

.pilares {
  display: flex;
  gap: 20px;
  justify-content: space-between;
  padding-bottom: 1rem;
}

.btn-pilar {
  flex: 1 1;
  background-color: #fff;
  padding: 1.5rem;
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.btn-pilar:hover {
  background-color: #9ab82f;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
}

.btn-pilar:hover h3 {
  color: #fff;
}

.btn-pilar.active {
  background-color: #64a555;
}

.btn-pilar.active:hover {
  background-color: #9ab82f;
}

.btn-pilar.active h3 {
  color: #fff;
}

/* Pilars styles */

.pilar-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9ef;
}

.table-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
  border-radius: 10px !important;
}

.group-title {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  background-color: #27ae60;
  margin-bottom: 1rem;
  font-size: 1.2rem !important;
  font-weight: 600 !important;
  color: #fff !important;
}

.column-title {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  background-color: #f9f9f9;
  margin-bottom: 1rem;
  font-size: 1rem !important;
  font-weight: 600 !important;
  color: #333 !important;
  text-align: center !important;
}

.subgroup-column {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center !important;
  border-right: 1px solid #ddd;
}

.indicador-column {
  border-right: 1px solid #ddd;
}

.certification-column,
.obrigatorio-column {
  display: inline-block;
  padding: 0;
  margin: 0;
  position: relative;
  text-align: center !important;
  border-right: 1px solid #ddd;
}

.info-column {
  display: inline-block;
  padding: 0;
  margin: 0;
  position: relative;
  color: #27ae60;
  text-align: center !important;
  border-right: 1px solid #ddd;
}

#info-icon {
  color: #27ae60;
  cursor: pointer;
}

.sim-column {
  display: inline-block;
  padding: 0;
  margin: 0;
  position: relative;
  text-align: center !important;
  border-right: 1px solid #ddd;
}

.sim-column .MuiCheckbox-root {
  display: inline-block;
  padding: 0;
  margin: 0;
}

.nao-column {
  display: inline-block;
  padding: 0;
  margin: 0;
  position: relative;
  text-align: center !important;
}

.nao-column .MuiCheckbox-root {
  display: inline-block;
  padding: 0;
  margin: 0;
}

.numeric-input input::placeholder {
  text-align: center !important;
}

/* buttons */

.buttons-container {
  display: flex;
  justify-content: right;
  gap: 20px;
  margin: 1rem 0;
}

/* Missing mandatory indicators styling */
.missing-mandatory-row {
  background-color: #ffebee !important;
  border-left: 4px solid #d32f2f !important;
}

.missing-mandatory-indicator {
  color: #d32f2f !important;
  font-weight: bold !important;
}

.missing-mandatory-checkbox {
  color: #d32f2f !important;
}

.missing-mandatory-row .MuiCheckbox-root {
  color: #d32f2f !important;
}

.missing-mandatory-row .MuiTextField-root .MuiOutlinedInput-root {
  border-color: #d32f2f !important;
}

.missing-mandatory-row .MuiTextField-root .MuiOutlinedInput-root.Mui-focused {
  border-color: #d32f2f !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/sg-pilars.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;AACf;;AAEA,2BAA2B;;AAE3B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;;AAElB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,YAAY;;AAEZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/* Certification Styles */\n\n.certifications-container {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #f8f9ef;\n}\n\n.create-certification,\n.edit-certification {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  padding: 1.5rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.create-certification .btn-add {\n  margin-bottom: 0;\n}\n\n.exploration-selector,\n.culture-selector {\n  display: flex;\n  color: #333;\n  background-color: #f0f0f0;\n  border: 1px solid #a1a1a1;\n  padding: 10px;\n  border-radius: 5px;\n  margin-right: 2rem;\n}\n\n.exploration-selector:hover,\n.culture-selector:hover {\n  border: 2px solid #27ae60;\n  outline: none;\n}\n\n/* Pilares Buttons Styles */\n\n.pilares-container {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #f8f9ef;\n}\n\n.pilares {\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n  padding-bottom: 1rem;\n}\n\n.btn-pilar {\n  flex: 1;\n  background-color: #fff;\n  padding: 1.5rem;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.btn-pilar:hover {\n  background-color: #9ab82f;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);\n}\n\n.btn-pilar:hover h3 {\n  color: #fff;\n}\n\n.btn-pilar.active {\n  background-color: #64a555;\n}\n\n.btn-pilar.active:hover {\n  background-color: #9ab82f;\n}\n\n.btn-pilar.active h3 {\n  color: #fff;\n}\n\n/* Pilars styles */\n\n.pilar-container {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #f8f9ef;\n}\n\n.table-container {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 3rem;\n  border-radius: 10px !important;\n}\n\n.group-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  background-color: #27ae60;\n  margin-bottom: 1rem;\n  font-size: 1.2rem !important;\n  font-weight: 600 !important;\n  color: #fff !important;\n}\n\n.column-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  background-color: #f9f9f9;\n  margin-bottom: 1rem;\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  color: #333 !important;\n  text-align: center !important;\n}\n\n.subgroup-column {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center !important;\n  border-right: 1px solid #ddd;\n}\n\n.indicador-column {\n  border-right: 1px solid #ddd;\n}\n\n.certification-column,\n.obrigatorio-column {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  text-align: center !important;\n  border-right: 1px solid #ddd;\n}\n\n.info-column {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  color: #27ae60;\n  text-align: center !important;\n  border-right: 1px solid #ddd;\n}\n\n#info-icon {\n  color: #27ae60;\n  cursor: pointer;\n}\n\n.sim-column {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  text-align: center !important;\n  border-right: 1px solid #ddd;\n}\n\n.sim-column .MuiCheckbox-root {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n}\n\n.nao-column {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  text-align: center !important;\n}\n\n.nao-column .MuiCheckbox-root {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n}\n\n.numeric-input input::placeholder {\n  text-align: center !important;\n}\n\n/* buttons */\n\n.buttons-container {\n  display: flex;\n  justify-content: right;\n  gap: 20px;\n  margin: 1rem 0;\n}\n\n/* Missing mandatory indicators styling */\n.missing-mandatory-row {\n  background-color: #ffebee !important;\n  border-left: 4px solid #d32f2f !important;\n}\n\n.missing-mandatory-indicator {\n  color: #d32f2f !important;\n  font-weight: bold !important;\n}\n\n.missing-mandatory-checkbox {\n  color: #d32f2f !important;\n}\n\n.missing-mandatory-row .MuiCheckbox-root {\n  color: #d32f2f !important;\n}\n\n.missing-mandatory-row .MuiTextField-root .MuiOutlinedInput-root {\n  border-color: #d32f2f !important;\n}\n\n.missing-mandatory-row .MuiTextField-root .MuiOutlinedInput-root.Mui-focused {\n  border-color: #d32f2f !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
